import {Component} from "@angular/core";
import {provideEntityModel, provideReportModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {SupplierInvoiceSearchModel} from "../supplier-invoice-search.model";
import {SupplierInvoiceEntityModel} from "../supplier-invoice-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {SupplierInvoiceReportModel} from "../../reports/supplier-invoice-report/supplier-invoice-report.model";

@Component({
    selector: "wbo-supplier-invoice-search-page",
    templateUrl: "./supplier-invoice-search-page.component.html",
    providers: [provideSearchModel(SupplierInvoiceSearchModel), provideEntityModel(SupplierInvoiceEntityModel), provideReportModel(SupplierInvoiceReportModel)]
})

export class SupplierInvoiceSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
